export default function Licences() {
  return (
    <p>
      The Customer shall use all Applications under a non-exclusive, non-transferrable licence, as set out in this Contract for Services and detailed in the confirmation email.  This licence permits the maximum number of Users detailed in the confirmation email to access the Applications at any given time and such access is only permitted through the site, unless otherwise agreed.
      <br /><br />
      All Applications provided by the Information Service Provider are the property of the Information Service Provider unless otherwise stated and shall be covered by the terms of the licence included in this Contract for Services.
    </p>
  );
}
